<template>
  <div class="container-fluid mb-7 mb-md-5">
    <router-view />
  </div>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';

export default {
  name: 'Workout',
  computed: {
    ...computedGetters(['isCreateWodButtonVisible']),
    isLightGreyPlan() {
      return this.$store.getters.getIsLightGreyPlan;
    }
  },
  watch: {
    isCreateWodButtonVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    },
    isLightGreyPlan: {
      immediate: true,
      handler: function(isAccessBlocked) {
        if (isAccessBlocked) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  }
};
</script>

<style lang="scss">
</style>
